import { useScrollToTop } from '@/hooks/useScrollToTop';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import TrendingSection from './components/TrendingSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  useScrollToTop();

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '蜜桃网站',
    url: 'https://mitao.readdy.ai',
    description: '蜜桃网站是专为年轻用户打造的甜蜜生活内容平台，涵盖时尚、美食、情感、生活方式等多元内容。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://mitao.readdy.ai/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '蜜桃网站是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '蜜桃网站是专为年轻用户打造的甜蜜生活内容平台，涵盖时尚、美食、情感、生活方式等多元内容，致力于用温暖、专业、有趣的内容陪伴每一位追求美好生活的年轻人。',
        },
      },
      {
        '@type': 'Question',
        name: '蜜桃网站有哪些内容分类？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '蜜桃网站涵盖时尚潮流、美食探店、情感故事、生活方式、旅行日记、美妆护肤等六大内容版块，满足不同用户的兴趣需求。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在蜜桃网站上找到感兴趣的内容？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '你可以通过首页的分类导航浏览不同板块，也可以使用搜索功能查找特定主题的文章。每周还有精选推荐和热门内容，帮助你发现更多精彩。',
        },
      },
      {
        '@type': 'Question',
        name: '蜜桃网站的内容是原创的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，蜜桃网站的内容由来自时尚、美食、心理学、旅行等不同领域的专业创作者团队原创撰写，每月产出超过200篇优质原创内容。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroBanner />
          <CategoryGrid />
          <FeaturedArticles />
          <TrendingSection />
          <NewsletterSection />
        </main>
        <Footer />
      </div>
    </>
  );
}